import React from "react";

import { Stack, Typography } from "@mui/material";

import { useDeviceDimensions } from "../../../hooks/useDeviceDimensions";
import { SpiceLevelIcon } from "../../SpiceLevelIcon/SpiceLevelIcon";

export const SpiceAndPrice = ({
  spiceLevel,
  price,
}: {
  spiceLevel?: number;
  price: string;
}) => {
  const { isLargeScreen } = useDeviceDimensions();
  return (
    <Stack
      direction={isLargeScreen ? "column" : "column-reverse"}
      gap={0.5}
      alignItems={"end"}
      // Holds its size while the name wraps around it, rather than being
      // squeezed out of the row.
      flexShrink={0}
    >
      {!!price ? (
        <Typography
          variant={"body1"}
          align="right"
          sx={(theme) => ({ fontFamily: theme.typography.fontFamily })}
        >
          {price}
        </Typography>
      ) : null}
      <SpiceLevelIcon level={spiceLevel} />
    </Stack>
  );
};
